import actionTypes from 'constants/actionTypes'
import defaultsDeep from 'lodash/defaultsDeep'

interface SignupState {
  isFetching: boolean
}

interface SignupAction {
  type?: string
}

const initialState: SignupState = {
  isFetching: false,
}

export default (state: SignupState = initialState, action: SignupAction): SignupState => {
  if (action.type === actionTypes.AUTH.SIGNUP.REQUEST) {
    return defaultsDeep(
      {
        isFetching: true
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.SIGNUP.RECEIVE) {
    return defaultsDeep(
      {
        isFetching: false
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.SIGNUP.FAIL) {
    return defaultsDeep(
      {
        isFetching: false
      },
      state
    )
  }
  return state
}
